/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".button-icon[_ngcontent-%COMP%]{position:absolute;top:-2px;left:1px}input.mat-input-element[_ngcontent-%COMP%]{position:relative;top:5px;left:42px}\n/*# sourceMappingURL=time-field.component.css.map*/"];
export { styles as styles };
